import React from 'react';
import { Modal, Header, Button, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';


const WarningModal = (props) => {
  
  return (
    <Modal open={props.open} onClose={props.closeModal} basic centered size='small' className="warningModal">
      <Header icon='window close outline' content='Request Failed' />
      <Modal.Content>
        <h3 style={{color:'red', }}>{props.message}</h3>
      </Modal.Content>
      <Modal.Actions>
        <Button color='blue' onClick={props.closeModal} inverted>
          <Icon name='checkmark' /> Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: 'CLOSE_WARNING_MODAL' }),
  };
};
const mapStateToProps = (state) => {
  return {
    open: state.warningModalReducer.showModal,
    message: state.warningModalReducer.message
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WarningModal);
